module.exports = __webpack_public_path__ + "img/google-play-co.d799d31.png";